
<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12 ui-md-12 background" >
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <h2 class="title" >{{this.titleAuthorization}}</h2>
        <h3 class="subTitle">{{this.subTitleAuthorization}} </h3>
      </div>
  </div>
  <div class="ui-g-12" style="margin-top: 2%;">
    <div class="ui-g-4 ui-sm-12">
      <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Envío de autorización" (click)="navigateNewAuthorization()"></button>
    </div>
  </div>
  <div class="ui-g-12" style="margin-top: 2%;">
    <div class="ui-g-2 ui-sm-12">
      <label for="range" style="color: #073c8f; font-family: poppins; ">Búsqueda por rango de fechas:</label>
    </div>
    <div class="ui-g-3 ui-sm-12">
      <!--<p-calendar id="range" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" yearRange="2000:2030" [(ngModel)]="rangeDates" [touchUI]="true" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>-->
      <p-calendar [(ngModel)]="firstDate"   dateFormat="dd/mm/yy" placeholder="Fecha Inicio" yearNavigator="true" yearRange="1950:2050" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
    </div>
    <div class="ui-g-3 ui-sm-12">
      <!--<p-calendar id="range" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" yearRange="2000:2030" [(ngModel)]="rangeDates" [touchUI]="true" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>-->
      <p-calendar [(ngModel)]="lastDate"   dateFormat="dd/mm/yy" placeholder="Fecha Fin" yearNavigator="true" yearRange="1950:2050" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
    </div>
    <div class="ui-g-4 ui-sm-12">
      <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Buscar" (click)="searchRange()"></button>
    </div>
  </div>
  <p-table [columns]="cols" [value]="authorizations" styleClass="p-datatable-responsive-demo" [lazy]="true" [loading]="loading"
           [paginator]="true" [rows]="10" [responsive]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-auth>
      <tr *ngIf="auth.detail.authorizationStatus !== undefined">
        <td>
            <p *ngIf="auth.detail.authorizationStatus.indexOf('AU') > -1" class="autorizada">{{auth.detail.authorizationStatusDescription}}</p>
            <p *ngIf="auth.detail.authorizationStatus.indexOf('DE') > -1" class="denegada" >{{auth.detail.authorizationStatusDescription}}</p>
            <p *ngIf="auth.detail.authorizationStatus.indexOf('EP') > -1" class="proceso" >{{auth.detail.authorizationStatusDescription}}</p>
            <p *ngIf="auth.detail.authorizationStatus.indexOf('FE') > -1" class="enviado" >{{auth.detail.authorizationStatusDescription}}</p>
            <p *ngIf="auth.detail.authorizationStatus.indexOf('FU') > -1" class="denegada" >{{auth.detail.authorizationStatusDescription}}</p>
        </td>
        <td class="color1" >
          <span class="p-column-title"><span class="p-column-title">{{auth.type}}</span></span>
        </td>
        <td >
          <span class="p-column-title">{{auth.detail.policyHolderCompleteCardNumber}}</span>
        </td>
        <td >
          <span class="p-column-title">{{auth.detail.authorizationCompleteNumber}}</span>
        </td>
        <td>
          <span class="p-column-title">{{auth.detail.policyHolderCompleteName}}</span>
        </td>
        <td >
          <span class="p-column-title">{{auth.detail.dueDate}}</span>
        </td>
        <td >
          <button  pButton type="button" class="ui-button-primary btn-dv" [disabled]="!(auth.detail.authorizationStatus.indexOf('AU') > -1 || auth.detail.authorizationStatus.indexOf('DE') > -1 || auth.detail.authorizationStatus.indexOf('FE') > -1 || auth.detail.authorizationStatus.indexOf('FU') > -1)" (click)="downloadPDF(auth.detail.authorizationCompleteNumber)" label="Descargar PDF"></button>
        </td>
        <td >
          <button pButton type="button" class="ui-button-primary btn-dv" (click)="detailAuth(auth.detail)" label="Ver Detalles"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-dialog [(visible)]="showDetail" (close)="showDetail=false" [closable]="true" [style]="{width: '80vw'}" >
      <div class="cardGray ui-g-12" *ngIf="showDetail">
        <div class="ui-g-12">
          <div class="card ui-g-12 ui-md-8 ui-lg-6">
            <div class="ui-g-4"><h4 class="noMg">Estado:</h4></div>
            <div class="ui-g-8" *ngIf="details.authorizationStatus.indexOf('AU') > -1">
              <p class="status1" >{{details.authorizationStatusDescription}}</p>
            </div>
            <div class="ui-g-8" *ngIf="details.authorizationStatus.indexOf('DE') > -1">
              <p class="status2" >{{details.authorizationStatusDescription}}</p>
            </div>
            <div class="ui-g-8" *ngIf="details.authorizationStatus.indexOf('PE') > -1">
              <p class="status3" >{{details.authorizationStatusDescription}}</p>
            </div>
            <div class="ui-g-8" *ngIf="details.authorizationStatus.indexOf('FE') > -1">
              <p class="status1" >Autorizada</p>
            </div>
            <div class="ui-g-8" *ngIf="details.authorizationStatus.indexOf('FU') > -1">
              <p class="status3" >{{details.authorizationStatusDescription}}</p>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">{{this.fb.getStringRC("global_authorization_complete_number")}}</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class=" card ui-g-12">
              <h4 class="result">{{details.authorizationCompleteNumber}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Nombre:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="result">{{details.policyHolderCompleteName}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Carnet:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4  class="result">{{details.policyHolderCompleteCardNumber}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Completado:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="result">{{details.finished}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Fecha de envío:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="result">{{details.sentDateTime}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Fecha de recepción:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="result">{{details.receptionDate}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="subTitle2">Fecha de vencimiento:</h4>
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="card ui-g-12">
              <h4 class="result">{{details.dueDate}}</h4>
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="card ui-g-12">
            <div class="ui-g-6">
              <h4 class="subTitle2">Enviado a los correos:</h4>
            </div>
            <div class="ui-g-12" style="word-wrap: break-word;">
              <h2>{{details.mailRecipient}}</h2>
            </div>
          </div>
        </div>
    </div>
  </p-dialog>
</div>
